import { TTagsManager } from '../../types/tag';
import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'bbox' as const;

export const geoBboxTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const bbox = getTermValue('bbox')(jsonQuery);

    return bbox ? [{ label: 'Область поиска', value: createTagValue(ID) }] : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['bbox'])(jsonQuery),
};
